import { render, staticRenderFns } from "./PatchRequestBCDPicker.vue?vue&type=template&id=3a7984dc&scoped=true"
import script from "./PatchRequestBCDPicker.vue?vue&type=script&lang=js"
export * from "./PatchRequestBCDPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7984dc",
  null
  
)

export default component.exports